import { useHistory, useLocation, Redirect, Route } from 'react-router-dom';
import {
  AppBar,
  Button,
  IconButton,
  Divider,
  Drawer,
  ListItemIcon,
  ListItemText,
  ToggleButton,
  Toolbar,
  Typography,
  Box,
  Link,
  Menu,
  MenuItem,
  MenuList,
  Stack,
} from '@mui/material';

import { Securables, SessionStorageItemIds } from './Enums'
import { useErrorDisplay } from './components/ErrorDisplay';
import OnTrue from './components/OnTrue';
import ConditionalDisplay from './components/ConditionalDisplay';
import TZGravatar from './components/TZGravatar';

import darklogo from './Images/ColorLogo.dark.svg';
import lightlogo from './Images/ColorLogo.light.svg';
import darkGlassBackground from './Images/synergist-glass-flow-dark-full-fabric.png';
import lightGlassBackground from './Images/synergist-glass-flow-light-bluegray-full-fabric.png';
import { glassFabricVeil } from './theme/glass';

import './App.css'

import Main from './pages/Main'
import CreateAccountPage from './pages/CreateAccountPage'
import EmployeeManagementPage from './pages/EmployeeManagementPage'
import AcceptInvitationPage from './pages/AcceptInvitationPage'
import DashboardPage from './pages/DashboardPage'
import ConsultantPage from './pages/ConsultantPage'
import MenuListEx, { MenuListExItemData } from './components/MenuListEx'

import DashboardIcon from '@mui/icons-material/Dashboard';
import TemplateManagementPage from './pages/TemplateManagementPage';
import ProficiencyManagementPage from './pages/ProficiencyManagementPage';
import ProficiencyGroupManagementPage from './pages/ProficiencyGroupManagementPage';

import DescriptionIcon from '@mui/icons-material/Description';
import ViewListIcon from '@mui/icons-material/ViewList';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PeopleIcon from '@mui/icons-material/People';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SettingsIcon from '@mui/icons-material/Settings';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import BadgeIcon from '@mui/icons-material/Badge';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';

import PositionManagementPage from './pages/PositionManagementPage';
import TalentManagementPage from './pages/TalentManagementPage';
import AssessmentManagementPage from './pages/AssessmentManagementPage';
import GroupManagementDisplay from './pages/GroupManagementDisplay';
import { useAccessInfo } from './contexts/AccessTokenProvider';
import { AccountBox, DarkMode, LightMode, ManageAccounts, Logout } from '@mui/icons-material';
import OrganizationSettingsPage from './pages/OrganizationSettingsPage';
import OnlyForRole from './components/OnlyForRole';
import { purple } from '@mui/material/colors';
import { SearchSystemUserItem } from './apiClients/SystemUserClient';
import ImpersonateUserPopup from './popups/ImpersonateUserPopup';
import I18NText from './components/I18NText';
import { useMsal } from "@azure/msal-react"
import { b2cPolicies, forgotPasswordRequest } from './AuthConfig';
import { AuthenticationResult, EventType, InteractionType } from '@azure/msal-browser';
import CreatedOrganization from './pages/CreatedOrganization';
import OnboardingPage from './pages/OnboardingPage';
import CompletedOnboardingReplayPage from './pages/CompletedOnboardingReplayPage';
import AssessmentPublicationReplayPage from './pages/AssessmentPublicationReplayPage';
import { SyntheticTemplateReplayRoute } from './pages/SyntheticTemplateReplayPage';
import { FinalizedLifecycleReplayRoute } from './pages/FinalizedLifecycleReplayPage';
import { RoleTemplateReplayRoute } from './pages/RoleTemplateReplayPage';
import { OngoingAssessmentReplayRoute } from './pages/OngoingAssessmentReplayPage';
import { AiReviewReplayRoute } from './pages/AiReviewReplayPage';
import StartOrganizationPage from './pages/StartOrganizationPage';
import AcceptSetupInvitationPage from './pages/AcceptSetupInvitationPage';
import { useEffect, useState } from 'react';
import SubscriptionPage from './pages/SubscriptionPage';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { alpha, useTheme } from '@mui/material/styles';
import { useSettingsContext } from './components/settings';
import { GoToLocation } from './Helpers';
import { IDENTITY_FIRST_ONBOARDING, SEQ_URL } from './Environment';
import { SeqLogger } from './utils/logger';
import { useSnackBarDisplay } from './components/SnackBarDisplay';
import ClientRequestsPage from './pages/ClientRequestsPage';
import SystemAdministrationPage from './pages/SystemAdministrationPage';
import { isSystemAdministrationAuthorizationPending, isSystemAdministrationPath, shouldRedirectFromSystemAdministration, SYSTEM_ADMINISTRATION_COSTS_PATH, SYSTEM_ADMINISTRATION_PATH } from './systemAdministration';
import { AppVersionWatcher } from './components/AppVersionWatcher';
import { useSubscriptionAccessBanner } from './hooks/useSubscriptionAccessBanner';
import useViewportMode from './hooks/useViewportMode';
import HelpCenterPage from './pages/HelpCenterPage';
import HelpLauncher from './help/HelpLauncher';
import CompletedOnboardingReplayMenuItem from './components/CompletedOnboardingReplayMenuItem';
import LoginPage, { AuthenticatedLoginRedirect } from './pages/LoginPage';
import { appShellViewportSx } from './layout/appShellLayout';
import EmployeePortalPage from './pages/EmployeePortalPage';
import EmployeeReviewPage from './pages/EmployeeReviewPage';
import EmployeeInvitationPage from './pages/EmployeeInvitationPage';
import ProducerDashboardPage from './pages/producer/ProducerDashboardPage';
import ProducerClientCompaniesPage from './pages/producer/ProducerClientCompaniesPage';
import ProducerTeamManagementPage from './pages/producer/ProducerTeamManagementPage';
import ProducerReportsPage from './pages/producer/ProducerReportsPage';
import ProducerInvitationPage from './pages/producer/ProducerInvitationPage';
import ProducerSystemAdminPage from './pages/producer/ProducerSystemAdminPage';
import ProducerPayoutsPage from './pages/producer/ProducerPayoutsPage';
import ProducerPayoutRunsPage from './pages/producer/ProducerPayoutRunsPage';
import PortalContextSwitcher from './components/PortalContextSwitcher';
import EmployeePortalContextEntry from './components/EmployeePortalContextEntry';
import {
    EMPLOYEE_PORTAL_PATH,
    PRODUCER_PORTAL_PATH,
    isEmployeePortalPath,
    isSupportedEmployeePortalRoute,
    isSupportedProducerPortalRoute,
} from './auth/portalRouting';
import { PortalContextKind } from './models/portal-context';

export const origConsoleError = console.error;
export const origConsoleWarn = console.warn;
export const origConsoleInfo = console.info;
export const origConsoleLog = console.log;
export const origConsoleDebug = console.debug;

const App = () => {

  const { instance } = useMsal();
  const theme = useTheme();
  const { themeMode, onToggleMode } = useSettingsContext();

  const [ErrorDisplay] = useErrorDisplay();
  const history = useHistory();
  const location = useLocation();
  const { isPhone, isTablet, isDesktop } = useViewportMode();
  const [navigationOpen, setNavigationOpen] = useState(false);
  const { accessInfo, hasRole, hasOneOfRoles, hasSubscriptionAccess, subscriptionRequired, login, logout, isLoggedIn, needsOnboarding, impersonate, clearImpersonation, isImpersonating } = useAccessInfo();
  const [SnackBarDisplay, setMessage] = useSnackBarDisplay();
  const systemAdministrationMode = isSystemAdministrationPath(location.pathname);
  const employeePortalSelected = accessInfo.currentPortalContext?.Kind === PortalContextKind.Employee;
  const producerPortalSelected = accessInfo.currentPortalContext?.Kind === PortalContextKind.Producer;
  const employeeInvitationPath = location.pathname.toLowerCase().endsWith('/employeeinvitation');
  const producerInvitationPath = ['/producerportal/invitation', '/producerportal/invitation/'].includes(location.pathname.toLowerCase());
  const showWorkspaceNavigation = isLoggedIn() && !employeePortalSelected && !producerPortalSelected && !employeeInvitationPath && !producerInvitationPath;
  const boundedWorkspacePage = isLoggedIn()
    && !systemAdministrationMode
    && (location.pathname === '/Help' || (location.pathname === '/' && isDesktop));

  const adminMenuSecurables = [
    Securables.synergist_admin,
    Securables.organization_administrator,
    Securables.organization_subscription,
    Securables.organization_consultant,
    Securables.organization_employee,
    Securables.orgsettings,
    Securables.profgroup,
  ];

  const desktopDrawerWidth = 240;
  const tabletRailWidth = 72;
  const expandedDrawerWidth = 280;
  const drawerWidth = showWorkspaceNavigation
    ? isDesktop ? desktopDrawerWidth : isTablet ? tabletRailWidth : 0
    : 0;
  const subscriptionNotActiveTime = 5000;
  const { bannerVisible, subscriptionNotActive } = useSubscriptionAccessBanner(
    isLoggedIn(),
    hasSubscriptionAccess,
    subscriptionNotActiveTime);

  useEffect(() => {
    if (isLoggedIn() && !hasSubscriptionAccess)
      setMessage('You are using the Demo version of Synergist with foundational functionality. We hope you enjoy it!');

    const seqLogger = new SeqLogger(accessInfo);
    console.error = seqLogger.error;
    console.warn = seqLogger.warn;
    console.info = seqLogger.info;
    console.log = seqLogger.log;
    console.debug = seqLogger.debug;

    window.onerror = function (message: string, source: string, lineno: number, colno: number, error: Error) {
      // call seq to log
      let seq = require('seq-logging/browser');
      let logger = new seq.Logger({ serverUrl: SEQ_URL });
      const stackTraceWithoutMessage = error?.stack?.replace(error?.message, '')?.replace('\n ', '');

      logger.emit({
        timestamp: new Date(),
        level: 'Error',
        messageTemplate: error.message,
        properties: {
          UserName: accessInfo.email,
          Organization: accessInfo.selectedOrganizationName,
          OrganizationId: accessInfo.selectedOrganizationId,
          StackTrace: stackTraceWithoutMessage,
          ComponentName: window.location.pathname,
        }
      });

      return false;
    }
  }, [accessInfo, hasSubscriptionAccess])

  const handleImpersonate = async (impUserInfo: SearchSystemUserItem, withAdmin: boolean) => {
    await impersonate(impUserInfo.UserId, impUserInfo.OrganizationId, withAdmin);
  }

  useEffect(() => { })

  useEffect(() => {
    setNavigationOpen(false);
  }, [location.pathname, isDesktop]);

  useEffect(() => {
    const callbackId = instance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_FAILURE) {
        if (event.error && event.error.errorMessage.indexOf("AADB2C90118") > -1) {
          if (event.interactionType === InteractionType.Redirect) {
            instance.loginRedirect(forgotPasswordRequest);
          } else if (event.interactionType === InteractionType.Popup) {
            instance.loginPopup(forgotPasswordRequest)
              .catch(e => {
                return;
              });
          }
        } else if (event.error?.errorMessage?.includes('AADB2C90091')) {
          const returnPath = sessionStorage.getItem('synergist:b2cReturnPath');
          if (returnPath) {
            sessionStorage.removeItem('synergist:b2cReturnPath');
            window.location.assign(`${returnPath}${returnPath.includes('?') ? '&' : '?'}auth=cancelled`);
          }
        }
      }

      if (event.eventType === EventType.LOGIN_SUCCESS) {
        if (event?.payload) {
          const authenticationResult = event.payload as AuthenticationResult;
          if (authenticationResult.account) {
            instance.setActiveAccount(authenticationResult.account);
          }
          /**
           * We need to reject id tokens that were not issued with the default sign-in policy.
           * "acr" claim in the token tells us what policy is used (NOTE: for new policies (v2.0), use "tfp" instead of "acr").
           * To learn more about B2C tokens, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
           */
          if (event.payload.idTokenClaims["acr"] === b2cPolicies.names.forgotPassword) {
            window.alert("Password has been reset successfully. \nPlease sign-in with your new password");
            return instance.logout();
          } else if (event.payload.idTokenClaims["tfp"] === b2cPolicies.names.signInAcceptInvitation) {
            // get the invitationId from session storage
            const invitationId = sessionStorage.getItem(SessionStorageItemIds.InvitationId);
            GoToLocation(`AcceptInvitation?id=${invitationId}`);

          }
          else {
            // AccessTokenProvider observes the completed MSAL interaction and
            // builds the application session in place. Reloading here used to
            // flash the signed-out site underneath a second loading overlay.
          }
        }
      }

      if (event.eventType === EventType.LOGOUT_START) {
        // remove access token
        sessionStorage.removeItem(SessionStorageItemIds.AccessToken);
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance]);

  function MainContent() {

    if (producerInvitationPath)
      return <Route exact path={`${PRODUCER_PORTAL_PATH}/Invitation`} component={ProducerInvitationPage} />;

    if (needsOnboarding) {
      return <>
        <Route exact path="/SetupInvitation" component={AcceptSetupInvitationPage} />
        <Route exact path="/Onboarding" component={OnboardingPage} />
        {!['/Onboarding', '/SetupInvitation'].includes(location.pathname) && <Redirect to="/Onboarding" />}
      </>;
    }

    if (isLoggedIn()) {
      if (employeeInvitationPath)
        return <Route exact path="/EmployeeInvitation" component={EmployeeInvitationPage} />;

      if (employeePortalSelected) {
        if (!isSupportedEmployeePortalRoute(location.pathname))
          return <Redirect to={EMPLOYEE_PORTAL_PATH} />;
        return <>
          <Route exact path={EMPLOYEE_PORTAL_PATH} component={EmployeePortalPage} />
          <Route exact path={`${EMPLOYEE_PORTAL_PATH}/Employment/:employmentId/Reviews/:reviewId`} component={EmployeeReviewPage} />
        </>;
      }

      if (producerPortalSelected) {
        if (!isSupportedProducerPortalRoute(location.pathname))
          return <Redirect to={PRODUCER_PORTAL_PATH} />;
        return <>
          <Route exact path={PRODUCER_PORTAL_PATH} component={ProducerDashboardPage} />
          <Route exact path={`${PRODUCER_PORTAL_PATH}/ClientCompanies`} component={ProducerClientCompaniesPage} />
          {hasRole(Securables.producer_admin, true) && <Route exact path={`${PRODUCER_PORTAL_PATH}/Payouts`} component={ProducerPayoutsPage} />}
          {hasRole(Securables.producer_admin, true) && <Route exact path={`${PRODUCER_PORTAL_PATH}/Team`} component={ProducerTeamManagementPage} />}
          <Route exact path={`${PRODUCER_PORTAL_PATH}/Reports`} component={ProducerReportsPage} />
        </>;
      }

      if (isEmployeePortalPath(location.pathname))
        return <EmployeePortalContextEntry />;

      if (systemAdministrationMode) {
        // Keep the deep link in place while workspace bootstrap resolves the
        // identity, but do not mount privileged administration views until
        // authorization is known.
        if (isSystemAdministrationAuthorizationPending(accessInfo.currentUserId))
          return null;

        if (shouldRedirectFromSystemAdministration(
          accessInfo.currentUserId,
          hasRole(Securables.synergist_admin, true)))
          return <Redirect to="/" />;

        return <>
          <Route exact path={SYSTEM_ADMINISTRATION_PATH} render={() => <SystemAdministrationPage view="overview" />} />
          <Route exact path={`${SYSTEM_ADMINISTRATION_PATH}/Organizations`} render={() => <SystemAdministrationPage view="organizations" />} />
          <Route exact path={`${SYSTEM_ADMINISTRATION_PATH}/WorkQueue`} render={() => <SystemAdministrationPage view="requests" />} />
          <Route exact path={SYSTEM_ADMINISTRATION_COSTS_PATH} render={() => <SystemAdministrationPage view="costs" />} />
          <Route exact path={`${SYSTEM_ADMINISTRATION_PATH}/Producers`} component={ProducerSystemAdminPage} />
          <Route exact path={`${SYSTEM_ADMINISTRATION_PATH}/Producers/:producerCompanyId`} component={ProducerSystemAdminPage} />
          <Route exact path={`${SYSTEM_ADMINISTRATION_PATH}/ProducerPayouts`} component={ProducerPayoutRunsPage} />
        </>;
      }

      return <>
        <Route exact path="/Login" component={AuthenticatedLoginRedirect} />
        <Route exact path="/Onboarding" component={OnboardingPage} />
        {hasOneOfRoles([Securables.organization_administrator, Securables.synergist_admin]) && <Route exact path="/OnboardingReplay/:view" component={CompletedOnboardingReplayPage} />}
        {hasOneOfRoles([Securables.organization_administrator, Securables.synergist_admin], true) && <Route exact path="/AssessmentPublicationReplay" component={AssessmentPublicationReplayPage} />}
        <Route exact path="/SyntheticTemplateReplay" component={SyntheticTemplateReplayRoute} />
        <Route exact path="/FinalizedLifecycleReplay" component={FinalizedLifecycleReplayRoute} />
        <Route exact path="/RoleTemplateReplay" component={RoleTemplateReplayRoute} />
        <Route exact path="/OngoingAssessmentReplay" component={OngoingAssessmentReplayRoute} />
        <Route exact path="/AiReviewReplay" component={AiReviewReplayRoute} />
        <Route exact path="/SetupInvitation" component={AcceptSetupInvitationPage} />
        <OnlyForRole role={Securables.dashboard}><Route exact path="/" component={DashboardPage} /></OnlyForRole>
        {subscriptionRequired && <OnlyForRole role={Securables.organization_subscription}><Route exact path="/SubscriptionPage" component={SubscriptionPage} /></OnlyForRole>}
        <OnlyForRole role={Securables.organization_employee}><Route exact path="/EmployeeManagement" component={EmployeeManagementPage} /></OnlyForRole>
        <Route exact path="/AcceptInvitation" component={AcceptInvitationPage} />
        <OnlyForRole role={Securables.organization_consultant}><Route exact path="/ConsultantManagement" component={ConsultantPage} /></OnlyForRole>
        <OnlyForRole role={Securables.profgroup}><Route exact path="/ProficiencyGroupManagement" component={ProficiencyGroupManagementPage} /></OnlyForRole>
        <OnlyForRole role={Securables.position}><Route exact path="/PositionManagement" component={PositionManagementPage} /></OnlyForRole>
        <OnlyForRole role={Securables.talent}><Route exact path="/TalentManagement" component={TalentManagementPage} /></OnlyForRole>
        <OnlyForRole role={Securables.template}><Route exact path="/TemplateManagement" component={TemplateManagementPage} /></OnlyForRole>
        <OnlyForRole role={Securables.proficiency}><Route exact path="/ProficiencyManagement" component={ProficiencyManagementPage} /></OnlyForRole>
        <OnlyForRole role={Securables.assessment}><Route exact path="/AssessmentManagement" component={AssessmentManagementPage} /></OnlyForRole>
        <OnlyForRole role={Securables.synergist_admin} preventOverrides><Route exact path="/GroupManagement" component={GroupManagementDisplay} /></OnlyForRole>
        {hasOneOfRoles([Securables.orgsettings, Securables.profgroup]) && <Route exact path="/OrganizationSettings" component={OrganizationSettingsPage} />}
        <Route exact path="/ClientRequests" component={ClientRequestsPage} />
        <Route exact path="/Help" component={HelpCenterPage} />
      </>;
    }
    //Not Authenticated
    return <>
      <Route exact path="/" component={Main} />
      <Route exact path="/CreateAccount" render={() => IDENTITY_FIRST_ONBOARDING ? <Redirect to="/Start" /> : <CreateAccountPage />} />
      <Route exact path="/Start" render={() => IDENTITY_FIRST_ONBOARDING ? <StartOrganizationPage /> : <Redirect to="/CreateAccount" />} />
      <Route exact path="/AcceptInvitation" component={AcceptInvitationPage} />
      <Route exact path="/SetupInvitation" component={AcceptSetupInvitationPage} />
      <Route exact path="/EmployeeInvitation" component={EmployeeInvitationPage} />
      <Route exact path={`${PRODUCER_PORTAL_PATH}/Invitation`} component={ProducerInvitationPage} />
      <Route exact path="/CreatedOrganization" render={() => IDENTITY_FIRST_ONBOARDING ? <Redirect to="/Start" /> : <CreatedOrganization />} />
      <Route exact path="/Login" render={() => <LoginPage onLogin={login} />} />
    </>;
  }

  const menuOptions: MenuListExItemData[] = [
    ...(hasRole(Securables.dashboard) ? [{ key: '/', onClick: () => history.push('/'), displayText: 'Dashboard', icon: <DashboardIcon />, children: [] }] : []),

    ...(hasRole(Securables.position) ? [{ key: '/PositionManagement', onClick: () => history.push('/PositionManagement'), displayText: 'Positions', icon: <AssignmentIcon />, children: [] }] : []),
    ...(hasRole(Securables.proficiency) ? [{ key: '/ProficiencyManagement', onClick: () => history.push('/ProficiencyManagement'), displayText: 'Proficiencies', icon: <ViewListIcon />, children: [] }] : []),
    ...(hasRole(Securables.template) ? [{ key: '/TemplateManagement', onClick: () => history.push('/TemplateManagement'), displayText: 'Templates', icon: <DescriptionIcon />, children: [] }] : []),

    ...(hasRole(Securables.assessment) ? [{ key: '/AssessmentManagement', onClick: () => history.push('/AssessmentManagement'), displayText: 'Development assessments', icon: <AssessmentIcon />, children: [] }] : []),

    ...(hasRole(Securables.talent) ? [{ key: '/TalentManagement', onClick: () => history.push('/TalentManagement'), displayText: 'Talent', icon: <PeopleIcon />, children: [] }] : []),

    { key: '/Help', onClick: () => history.push('/Help'), displayText: 'Help Center', icon: <HelpOutlineRoundedIcon />, children: [] },
  ];

  const adminMenuOptions: MenuListExItemData[] = [
    ...(hasRole(Securables.organization_subscription) && subscriptionRequired ? [{ key: '/SubscriptionPage', onClick: () => history.push('/SubscriptionPage'), displayText: 'Subscription', icon: <SubscriptionsIcon />, children: [] }] : []),
    ...(hasRole(Securables.organization_employee) ? [{ key: '/EmployeeManagement', onClick: () => history.push('/EmployeeManagement'), displayText: 'Employees', icon: <BadgeIcon />, children: [] }] : []),
    ...(hasRole(Securables.organization_consultant) ? [{ key: '/ConsultantManagement', onClick: () => history.push('/ConsultantManagement'), displayText: 'Consultants', icon: <SupportAgentIcon />, children: [] }] : []),
    { key: '/ClientRequests', onClick: () => history.push('/ClientRequests'), displayText: 'Support', icon: <ContactSupportOutlinedIcon />, children: [] },
    ...(hasOneOfRoles([Securables.orgsettings, Securables.profgroup]) ? [{ key: '/OrganizationSettings', onClick: () => history.push('/OrganizationSettings'), displayText: 'Org Settings', icon: <SettingsIcon />, children: [] }] : [])
  ];

  const systemAdministrationMenuOptions: MenuListExItemData[] = [
    { key: '/SystemAdministration', onClick: () => history.push('/SystemAdministration'), displayText: 'Dashboard', icon: <AdminPanelSettingsOutlinedIcon />, children: [] },
    { key: '/SystemAdministration/Organizations', onClick: () => history.push('/SystemAdministration/Organizations'), displayText: 'Organizations', icon: <ApartmentRoundedIcon />, children: [] },
    { key: '/SystemAdministration/WorkQueue', onClick: () => history.push('/SystemAdministration/WorkQueue'), displayText: 'Work Queue', icon: <AssignmentLateOutlinedIcon />, children: [] },
    { key: '/SystemAdministration/Producers', onClick: () => history.push('/SystemAdministration/Producers'), displayText: 'Producers', icon: <StorefrontRoundedIcon />, children: [] },
    { key: '/SystemAdministration/ProducerPayouts', onClick: () => history.push('/SystemAdministration/ProducerPayouts'), displayText: 'Producer Payouts', icon: <PaidRoundedIcon />, children: [] },
    { key: SYSTEM_ADMINISTRATION_COSTS_PATH, onClick: () => history.push(SYSTEM_ADMINISTRATION_COSTS_PATH), displayText: 'Azure Costs', icon: <PaidRoundedIcon />, children: [] },
  ];

  const closeAfterNavigation = (options: MenuListExItemData[]): MenuListExItemData[] => options.map(item => ({
    ...item,
    onClick: item.onClick ? async () => {
        await item.onClick();
        setNavigationOpen(false);
      } : item.onClick,
    children: closeAfterNavigation(item.children),
  }));

  const renderNavigation = (compact: boolean, closeOnNavigate: boolean) => {
    const primaryOptions = systemAdministrationMode ? systemAdministrationMenuOptions : menuOptions;
    const visiblePrimaryOptions = closeOnNavigate ? closeAfterNavigation(primaryOptions) : primaryOptions;
    const visibleAdminOptions = closeOnNavigate ? closeAfterNavigation(adminMenuOptions) : adminMenuOptions;

    return <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: 0,
        overflowX: 'hidden',
        paddingBottom: 'env(safe-area-inset-bottom)',
        ...(compact && {
          '& .MuiListItemButton-root': {
            justifyContent: 'center',
            minHeight: 48,
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
          },
          '& .MuiListItemIcon-root': {
            minWidth: 0,
            justifyContent: 'center',
          },
          '& .MuiListItemText-root': {
            display: 'none',
          },
        }),
      }}>
      <Toolbar sx={{ backgroundColor: 'transparent', gap: 1.5, justifyContent: compact ? 'center' : 'flex-start', flexShrink: 0 }}>
        {!systemAdministrationMode && <img
          src={themeMode === 'dark' ? darklogo : lightlogo}
          className="App-logo"
          alt="Synergist Pro"
          style={compact ? { width: 36, height: 36 } : undefined}
        />}
        {systemAdministrationMode && !compact && (
          <Typography variant="subtitle2" fontWeight={800}>System Administration</Typography>
        )}
        {systemAdministrationMode && compact && <AdminPanelSettingsOutlinedIcon color="primary" />}
      </Toolbar>
      <Divider />
      <Box sx={{ overflowY: 'auto', overflowX: 'hidden', flex: '1 1 auto' }}>
        <MenuListEx options={visiblePrimaryOptions} showToolTip={compact} />
      </Box>
      <ConditionalDisplay ifTrue={!systemAdministrationMode && hasOneOfRoles(adminMenuSecurables) && visibleAdminOptions.length > 0}>
        <Stack sx={{ flexShrink: 0 }}>
          <Divider />
          <MenuListEx options={visibleAdminOptions} showToolTip={compact} />
        </Stack>
      </ConditionalDisplay>
    </Box>;
  };

  return (
    <Box
      data-testid="app-shell"
      sx={{
        display: 'flex',
        ...appShellViewportSx({ isDesktop, boundedWorkspacePage }),
        backgroundColor: theme.palette.background.default,
        backgroundImage: `${glassFabricVeil(theme)}, url(${themeMode === 'dark' ? darkGlassBackground : lightGlassBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'left bottom',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: isPhone ? 'scroll' : 'fixed',
        '@media (prefers-reduced-transparency: reduce)': {
          backgroundImage: `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${
            themeMode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100]
          } 100%)`,
        },
        '@media print': {
          backgroundColor: theme.palette.common.white,
          backgroundImage: 'none',
        },
      }}
    >
      <ErrorDisplay />
      <AppVersionWatcher />
      <AppBar
        position="fixed"
        sx={!isDesktop
          ? { width: '100%', ml: 0, zIndex: theme.zIndex.drawer + 1 }
          : systemAdministrationMode
            ? { width: '100%', ml: 0, zIndex: theme.zIndex.drawer + 1 }
            : { width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}>
        <Toolbar sx={!isDesktop ? {
          minHeight: { xs: 56, sm: 64 },
          gap: 0.75,
          px: { xs: 1, sm: 1.5 },
          paddingTop: 'env(safe-area-inset-top)',
          paddingLeft: 'max(env(safe-area-inset-left), 8px)',
          paddingRight: 'max(env(safe-area-inset-right), 8px)',
        } : undefined}>
          {showWorkspaceNavigation && !isDesktop && (
            <IconButton
              color="inherit"
              edge="start"
              aria-label="Open navigation"
              aria-controls="responsive-navigation"
              aria-expanded={navigationOpen}
              onClick={() => setNavigationOpen(true)}
              sx={{ width: 44, height: 44, flexShrink: 0 }}>
              <MenuRoundedIcon />
            </IconButton>
          )}
          {isLoggedIn() && systemAdministrationMode && isDesktop && (
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: drawerWidth, flexShrink: 0, pr: 3 }}>
              <img src={themeMode === 'dark' ? darklogo : lightlogo} className="App-logo" alt="Synergist Pro" />
              <Typography variant="subtitle2" fontWeight={800} lineHeight={1.15} whiteSpace="nowrap">
                System Administration
              </Typography>
            </Stack>
          )}
          {isLoggedIn() && employeePortalSelected && isDesktop && (
            <Stack direction="row" spacing={1.5} alignItems="center">
              <img src={themeMode === 'dark' ? darklogo : lightlogo} className="App-logo" alt="Synergist Pro" />
              <Typography variant="subtitle2" fontWeight={800} whiteSpace="nowrap">Personal development</Typography>
            </Stack>
          )}
          {isLoggedIn() && !isDesktop && (
            systemAdministrationMode
              ? <AdminPanelSettingsOutlinedIcon aria-label="System Administration" />
              : <img
                src={themeMode === 'dark' ? darklogo : lightlogo}
                alt="Synergist Pro"
                style={{ width: isPhone ? 30 : 36, height: isPhone ? 30 : 36, objectFit: 'contain' }}
              />
          )}
          <OnTrue test={!((isLoggedIn()))}>
            <img src={themeMode === 'dark' ? darklogo : lightlogo} className="App-logo" alt="logo" />
          </OnTrue>
          <Box component="div" sx={{ flexGrow: 1 }} />
          {isLoggedIn() ? (
            <Stack direction="row" spacing={isPhone ? 0.5 : 1.5} alignItems="center">
              {!employeePortalSelected && !employeeInvitationPath && <HelpLauncher />}
              <ToggleButton
                value="dark"
                selected={themeMode === 'dark'}
                onChange={onToggleMode}
                size="small"
                aria-label="Toggle dark mode"
                sx={{
                  borderRadius: '999px',
                  px: 1.25,
                  minWidth: 40,
                  borderColor: alpha(theme.palette.common.white, themeMode === 'dark' ? 0.2 : 0.5),
                  color: themeMode === 'dark' ? theme.palette.grey[100] : theme.palette.text.secondary,
                  backgroundColor: themeMode === 'dark' ? alpha(theme.palette.common.white, 0.08) : 'transparent',
                  '&:hover': {
                    backgroundColor: themeMode === 'dark' ? alpha(theme.palette.common.white, 0.16) : theme.palette.action.hover,
                  },
                  '&.Mui-selected': {
                    backgroundColor: themeMode === 'dark' ? alpha(theme.palette.common.white, 0.12) : alpha(theme.palette.primary.main, 0.12),
                    color: themeMode === 'dark' ? theme.palette.grey[50] : theme.palette.primary.main,
                    borderColor: alpha(theme.palette.common.white, themeMode === 'dark' ? 0.28 : 0.5),
                    '&:hover': {
                      backgroundColor: themeMode === 'dark' ? alpha(theme.palette.common.white, 0.2) : alpha(theme.palette.primary.main, 0.18),
                    },
                  },
                }}
              >
                {themeMode === 'dark' ? <DarkMode fontSize="small" /> : <LightMode fontSize="small" />}
              </ToggleButton>
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <>
                    <Box
                      {...bindTrigger(popupState)}
                      aria-label="Open account menu"
                      sx={!isDesktop ? { cursor: 'pointer', borderRadius: '999px', minWidth: 44, minHeight: 44, display: 'grid', placeItems: 'center' } : undefined}>
                      <Stack direction='row' spacing={isPhone ? 0 : 2} alignItems="center">
                        {!isPhone && <Stack sx={isTablet ? { minWidth: 0, maxWidth: 180 } : undefined}>
                          <Typography variant="caption" noWrap={isTablet} sx={{ flexGrow: 1 }}>{`${accessInfo.given_name} ${accessInfo.family_name}`}</Typography>
                          <Typography variant="caption" noWrap={isTablet} sx={{ flexGrow: 1 }}>
                            {systemAdministrationMode
                              ? 'System Administration'
                              : employeeInvitationPath
                                ? 'Invitation confirmation'
                                : employeePortalSelected
                                  ? 'Personal development'
                                  : producerPortalSelected
                                    ? accessInfo.selectedProducerCompanyName || 'Producer portal'
                                    : accessInfo.selectedOrganizationName}
                          </Typography>
                        </Stack>}
                        <TZGravatar email={accessInfo.email} size={isPhone ? 32 : 35} />
                      </Stack>
                    </Box>

                    <Menu {...bindMenu(popupState)} PaperProps={isPhone ? { sx: { width: 'calc(100vw - 24px)', maxWidth: 360 } } : undefined}>
                      <Box sx={{ padding: '0px 5px', maxHeight: isPhone ? 'calc(100dvh - 96px)' : 'none', overflowY: isPhone ? 'auto' : 'visible' }}>
                        {!systemAdministrationMode && !employeeInvitationPath && <PortalContextSwitcher onNavigate={popupState.close} />}
                        <Typography sx={{ color: purple[500], paddingTop: theme.spacing(0), marginLeft: theme.spacing(2) }}>
                          {systemAdministrationMode ? 'System Administration' : employeeInvitationPath ? 'Invitation account' : 'Account'}
                        </Typography>
                        <MenuList dense>
                          {systemAdministrationMode ? <MenuItem onClick={() => { popupState.close(); history.push('/'); }} dense>
                            <ListItemIcon><ArrowBackRoundedIcon /></ListItemIcon>
                            <ListItemText>Return to Synergist Pro</ListItemText>
                          </MenuItem> : !employeePortalSelected && !employeeInvitationPath ? <>
                          <MenuItem onClick={() => { popupState.close(); history.push('/MyAccount'); }} dense>
                            <ListItemIcon>
                              <AccountBox />
                            </ListItemIcon>
                            <I18NText>My account</I18NText>
                          </MenuItem>
                          <MenuItem onClick={() => { popupState.close(); history.push('/ClientRequests?new=FeatureRequest'); }} dense>
                            <ListItemIcon><LightbulbOutlinedIcon /></ListItemIcon>
                            <ListItemText>Request a feature</ListItemText>
                          </MenuItem>
                          <MenuItem onClick={() => { popupState.close(); history.push('/ClientRequests?new=Issue'); }} dense>
                            <ListItemIcon><BugReportOutlinedIcon /></ListItemIcon>
                            <ListItemText>Report an issue</ListItemText>
                          </MenuItem>
                          <OnTrue test={hasRole(Securables.synergist_admin, true)}>
                            <MenuItem onClick={() => { popupState.close(); history.push('/SystemAdministration'); }} dense>
                              <ListItemIcon><AdminPanelSettingsOutlinedIcon /></ListItemIcon>
                              <ListItemText>System Administration</ListItemText>
                            </MenuItem>
                          </OnTrue>
                          <OnTrue test={hasOneOfRoles([Securables.synergist_admin, Securables.impersonate], true) && !isImpersonating()}>
                            <ImpersonateUserPopup onSelected={async (userInfo, withAdmin) => { popupState.close(); await handleImpersonate(userInfo, withAdmin); }} />
                          </OnTrue>
                          <OnTrue test={isImpersonating()}>

                            <MenuItem onClick={async () => { popupState.close(); await clearImpersonation(); }} dense>
                              <ListItemIcon>
                                <ManageAccounts />
                              </ListItemIcon>
                              <I18NText>Clear Impersonation</I18NText>
                            </MenuItem>
                          </OnTrue>
                          <CompletedOnboardingReplayMenuItem onNavigate={popupState.close} />
                          <OnTrue test={hasOneOfRoles([Securables.synergist_admin, Securables.organization_administrator])}>
                            <MenuItem onClick={() => { popupState.close(); history.push('/CreateAccount'); }} dense>
                              <ListItemIcon>
                                <ManageAccounts />
                              </ListItemIcon>
                              <I18NText>Create New Organization</I18NText>
                            </MenuItem>
                          </OnTrue>
                          </> : null}
                          <MenuItem onClick={() => { popupState.close(); logout(); }} dense>
                            <ListItemIcon>
                              <Logout />
                            </ListItemIcon>
                            <I18NText>Logout</I18NText>
                          </MenuItem>
                        </MenuList>
                        {!systemAdministrationMode && <><Divider style={{ marginTop: '15px' }} /><Typography fontSize='12px'>Don't see your image? Create a <Link href="https://en.gravatar.com/" target='_blank'>Gravitar.</Link></Typography></>}
                      </Box>
                    </Menu>
                  </>
                )}
              </PopupState>
            </Stack>
          ) : (isLoggedIn() && accessInfo.organizations.length === 0 ? (
            <>
              <Button color="inherit" onClick={() => logout()} sx={!isDesktop ? { minHeight: 44 } : undefined}><I18NText>Logout</I18NText></Button>
            </>
          ) : (
            <>
              <Button color="inherit" onClick={() => login()} sx={!isDesktop ? { minHeight: 44 } : undefined}><I18NText>Login</I18NText></Button>
              <Button color="secondary" onClick={() => history.push(IDENTITY_FIRST_ONBOARDING ? "/Start" : "/CreateAccount")} sx={!isDesktop ? { minHeight: 44 } : undefined}><I18NText>Create Account</I18NText></Button>
            </>
          ))}
        </Toolbar>
      </AppBar>
      <ConditionalDisplay ifTrue={showWorkspaceNavigation && (isDesktop || isTablet)}>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
            },
          }}
          variant='permanent'
          anchor='left'>
          {isDesktop ? <>
            <Toolbar sx={{ backgroundColor: 'transparent', gap: 1.5 }}>
              {!systemAdministrationMode && <img src={themeMode === 'dark' ? darklogo : lightlogo} className="App-logo" alt="logo" />}
            </Toolbar>
            <Divider />
            <MenuListEx options={systemAdministrationMode ? systemAdministrationMenuOptions : menuOptions} />
            <div style={{ height: '100%' }}></div>
            <ConditionalDisplay ifTrue={!systemAdministrationMode && hasOneOfRoles(adminMenuSecurables) && adminMenuOptions.length > 0}>
              <Stack>
                <Divider />
                <MenuListEx options={adminMenuOptions} />
              </Stack>
            </ConditionalDisplay>
          </> : renderNavigation(true, false)}
        </Drawer>
      </ConditionalDisplay>
      <Drawer
        id="responsive-navigation"
        variant="temporary"
        anchor="left"
        open={showWorkspaceNavigation && !isDesktop && navigationOpen}
        onClose={() => setNavigationOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: isDesktop ? 'none' : 'block',
          '& .MuiDrawer-paper': {
            width: `min(${expandedDrawerWidth}px, calc(100vw - 32px))`,
            boxSizing: 'border-box',
            paddingTop: 'env(safe-area-inset-top)',
          },
        }}>
        {renderNavigation(false, true)}
      </Drawer>
      <Box
        component="main"
        sx={isDesktop ? {
          flexGrow: 1,
          height: boundedWorkspacePage ? 'calc(100vh - 16px)' : '100vh',
          minHeight: 0,
          width: '100',
          margin: theme.spacing(1),
          ...(boundedWorkspacePage && {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }),
          backgroundColor: 'transparent',
          backgroundImage: 'none',
          border: 'none',
          boxShadow: 'none',
        } : {
          flexGrow: 1,
          minWidth: 0,
          minHeight: boundedWorkspacePage ? 0 : isPhone ? '100dvh' : '100vh',
          height: boundedWorkspacePage
            ? isPhone ? '100dvh' : 'calc(100dvh - 16px)'
            : 'auto',
          width: '100%',
          margin: isPhone ? 0 : theme.spacing(1),
          ...(boundedWorkspacePage && {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }),
          paddingLeft: isPhone ? 'env(safe-area-inset-left)' : 0,
          paddingRight: isPhone ? 'env(safe-area-inset-right)' : 0,
          paddingBottom: isPhone && subscriptionNotActive && bannerVisible
            ? 'calc(88px + env(safe-area-inset-bottom))'
            : isPhone ? 'env(safe-area-inset-bottom)' : 0,
          backgroundColor: 'transparent',
          backgroundImage: 'none',
          border: 'none',
          boxShadow: 'none',
        }}
      >
        <Toolbar sx={!isDesktop ? {
          minHeight: { xs: 56, sm: 64 },
          paddingTop: 'env(safe-area-inset-top)',
          flexShrink: 0,
        } : boundedWorkspacePage ? { flexShrink: 0 } : undefined} />
        <ConditionalDisplay ifTrue={showWorkspaceNavigation && !systemAdministrationMode && !bannerVisible && subscriptionNotActive}>
          <SnackBarDisplay displayMs={subscriptionNotActiveTime} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} />
        </ConditionalDisplay>
        <MainContent />
        <ConditionalDisplay ifTrue={showWorkspaceNavigation && !systemAdministrationMode && subscriptionNotActive && bannerVisible}>
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              left: drawerWidth,
              width: `calc(100vw - ${drawerWidth}px)`,
              boxSizing: 'border-box',
              backgroundColor: theme.palette.success.dark,
              color: theme.palette.success.contrastText,
              paddingTop: theme.spacing(1),
              paddingRight: isPhone ? 'max(env(safe-area-inset-right), 8px)' : theme.spacing(1),
              paddingBottom: isPhone ? 'calc(env(safe-area-inset-bottom) + 8px)' : theme.spacing(1),
              paddingLeft: isPhone ? 'max(env(safe-area-inset-left), 8px)' : theme.spacing(1),
              textAlign: 'center',
              zIndex: theme.zIndex.appBar,
            }}>
            <Typography variant='caption'>Reminder: You have foundational access to create Positions and build Position Templates but you will not be able to Manage Talent. Visit the <Link href="/SubscriptionPage" style={{ color: theme.palette.success.contrastText }}>Subscription page</Link> when you are ready!</Typography>
          </Box>
        </ConditionalDisplay>
      </Box>
    </Box>
  );
};
export default App;
